import AIMealPlanModal from './AIMealPlanModal';

export default AIMealPlanModal;
